// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"outsideMsTeams_wrapper__129h1","svg":"outsideMsTeams_svg__3ljU2"};